var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimePendingImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17003_29652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.83 85.17C182.83 98.62 178.84 111.77 171.37 122.95C163.9 134.13 153.28 142.85 140.85 148C128.42 153.15 114.75 154.49 101.56 151.87C88.3698 149.25 76.2498 142.77 66.7398 133.26C57.2298 123.75 50.7498 111.63 48.1298 98.44C45.5098 85.25 46.8498 71.58 51.9998 59.15C57.1498 46.72 65.8598 36.1 77.0498 28.63C88.2298 21.16 101.38 17.17 114.83 17.17C132.86 17.18 150.15 24.35 162.9 37.1C175.65 49.85 182.82 67.14 182.83 85.17Z",
    fill: "#FAEEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.823 59.5178C125.208 58.8716 123.915 59.5178 123.269 61.1333C122.623 62.4257 122.623 64.0412 124.885 64.6874C134.901 68.8877 140.393 81.4887 136.193 92.151C131.67 102.813 119.392 108.306 108.407 103.783C98.0673 99.5823 92.5746 88.2738 96.1287 77.6114L100.652 79.5501L98.3904 65.0105L86.7588 73.7342L90.9591 75.3498C86.4357 88.5969 92.8977 103.136 106.145 108.629C119.715 114.122 135.547 107.66 141.04 93.7665C146.532 80.8425 140.07 65.3336 126.823 59.5178Z",
    fill: "#702D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.239 72.4414C124.885 71.149 124.239 69.8566 122.946 69.2104H122.3C121.008 68.5642 119.715 69.2104 119.069 70.5028L113.899 83.4268L104.853 87.304C103.56 87.9502 102.914 89.5657 103.56 90.8581C104.206 92.1505 105.499 92.7967 107.114 92.1505L117.13 87.9502C117.13 87.9502 117.13 87.9502 117.453 87.9502C118.1 87.6271 118.423 87.304 118.746 86.6578L124.239 72.4414Z",
    fill: "#702D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.83 85.17C182.83 98.62 178.84 111.77 171.37 122.95C163.9 134.13 153.28 142.85 140.85 148C128.42 153.15 114.75 154.49 101.56 151.87C88.3698 149.25 76.2498 142.77 66.7398 133.26C57.2298 123.75 50.7498 111.63 48.1298 98.44C45.5098 85.25 46.8498 71.58 51.9998 59.15C57.1498 46.72 65.8598 36.1 77.0498 28.63C88.2298 21.16 101.38 17.17 114.83 17.17C132.86 17.18 150.15 24.35 162.9 37.1C175.65 49.85 182.82 67.14 182.83 85.17Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6756 148.806C52.3084 151.905 52.0102 155.127 50.8174 158.05C49.6246 160.974 47.5882 163.483 44.9627 165.258C42.3444 167.025 39.2534 167.985 36.0897 168C32.9259 168.014 29.8276 167.091 27.1875 165.352C24.5475 163.614 22.4819 161.12 21.2528 158.21C20.0237 155.294 19.6891 152.079 20.2928 148.974C20.8892 145.868 22.4019 143.01 24.6275 140.763C26.853 138.515 29.6967 136.973 32.795 136.341C34.8532 135.904 36.977 135.89 39.0425 136.282C41.108 136.675 43.079 137.475 44.8318 138.639C46.5845 139.795 48.0973 141.294 49.2683 143.039C50.4392 144.785 51.2611 146.741 51.6683 148.806H51.6756Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3496 41.56C56.9096 30.75 71.4096 23.61 87.0296 21.06C102.64 18.49 118.67 20.62 133.08 27.16C147.49 33.7 159.63 44.37 167.98 57.82C176.33 71.26 180.5 86.88 179.97 102.69C179.44 118.5 174.23 133.8 165 146.66C155.77 159.52 142.94 169.34 128.13 174.9C113.32 180.46 97.1896 181.5 81.7796 177.9C66.3696 174.3 52.3796 166.21 41.5696 154.65C27.0796 139.14 19.3496 118.53 20.0596 97.32C20.7696 76.12 29.8696 56.07 45.3596 41.57L45.3496 41.56Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.21 20L29.87 23.73",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7398 25.97L34.0098 26.63",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7704 34.5L31.1104 30.78",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2402 28.53L26.9702 27.87",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0107 26.63C33.5507 26.71 33.0707 26.7 32.6107 26.6C32.1507 26.5 31.7207 26.31 31.3307 26.04C30.9507 25.77 30.6207 25.43 30.3707 25.03C30.1207 24.63 29.9507 24.19 29.8707 23.73C29.9507 24.19 29.9407 24.67 29.8407 25.13C29.7407 25.59 29.5507 26.02 29.2807 26.41C29.0107 26.8 28.6707 27.12 28.2707 27.38C27.8707 27.63 27.4307 27.8 26.9707 27.89C27.4307 27.81 27.9107 27.82 28.3707 27.92C28.8307 28.02 29.2607 28.21 29.6507 28.48C30.0407 28.75 30.3607 29.09 30.6207 29.49C30.8707 29.89 31.0407 30.33 31.1207 30.79C31.0407 30.33 31.0507 29.85 31.1507 29.39C31.2507 28.93 31.4407 28.5 31.7107 28.11C31.9807 27.73 32.3207 27.4 32.7207 27.14C33.1207 26.89 33.5607 26.72 34.0207 26.63H34.0107Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 180C177.31 180 180 177.31 180 174C180 170.69 177.31 168 174 168C170.69 168 168 170.69 168 174C168 177.31 170.69 180 174 180Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17003_29652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePendingImage);
export default __webpack_public_path__ + "static/media/TimePendingImage.d3291bfcd4da6d5ff50f9b7040b93aa3.svg";
export { ForwardRef as ReactComponent };